import {
  RECENT_SEARCHES_KEY,
  RECENT_SEARCHES_MAX,
  type RecentSearch,
} from "@/features/search/types";
import {
  isMeaningfulRecentSearch,
  normalizeRecentSearchForStorage,
  recentSearchDedupeKey,
} from "./recent-search-utils";

function getRecentSearches(): RecentSearch[] {
  try {
    const raw = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return (parsed as RecentSearch[])
      .map((entry) => normalizeRecentSearchForStorage(entry))
      .filter((entry) => isMeaningfulRecentSearch(entry));
  } catch {
    return [];
  }
}

function saveRecentSearch(search: RecentSearch): void {
  const normalized = normalizeRecentSearchForStorage(search);
  if (!isMeaningfulRecentSearch(normalized)) return;

  try {
    const existing = getRecentSearches();
    const key = recentSearchDedupeKey(normalized);
    const filtered = existing.filter((s) => recentSearchDedupeKey(s) !== key);
    const updated = [normalized, ...filtered].slice(0, RECENT_SEARCHES_MAX);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("recent-searches-changed"));
  } catch {
    // localStorage unavailable or quota exceeded
  }
}

function clearRecentSearches(): void {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch {
    // localStorage unavailable
  }
}

export { clearRecentSearches, getRecentSearches, saveRecentSearch };
